var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"milestone-tooltip-progress-indicator"},[(_vm.isMilestoneInProgress)?_c('div',{staticClass:"milestone-tooltip-progress-indicator__background",style:({
      backgroundColor: _vm.indicatorColor,
    }),attrs:{"data-testid":"background"}}):_vm._e(),_c('div',{staticClass:"milestone-tooltip-progress-indicator__foreground",style:({
      borderBottomColor: _vm.indicatorColor,
      borderBottomStyle: _vm.foregroundType,
      width: _vm.foregroundWidth,
    }),attrs:{"data-testid":"foreground"}})])}
var staticRenderFns = []

export { render, staticRenderFns }